module.exports = __webpack_public_path__ + "img/VirtualMachins.217b5d7.svg";